import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { DocumentModel } from '@data-layer/models/documents';

@Injectable({
  providedIn: 'root',
})
export class MarineInsuranceDocumentsRepository {
  constructor(private apiService: ApiService) {}

  public getDocuments(shipmentId: number, isShowLoader?: boolean): Observable<DocumentModel> {
    return this.apiService.get<DocumentModel>(
      `${environment.url.prefixInsurance}shipments/${shipmentId}/documents`,
      {
        params: {
          shipmentId,
        },
      },
      {
        isShowLoader,
      },
    );
  }
}
